import { FC } from 'react';
import { useNavigate } from 'react-router';
import { IMultiDomainState } from 'Store/MultiDomain/interface/IMultiDomainState';
import { loadImage } from 'Utils/MultidomailUtils';
import { MenuLogoStyled } from './styles';

export interface IMenuLogo {
  image: string;
  imageCollapse: string;
  isCollapsed: boolean;
  domain: IMultiDomainState;
}

const MenuLogo: FC<IMenuLogo> = ({
  image,
  imageCollapse,
  isCollapsed,
  domain
}) => {
  const navigate = useNavigate();

  return (
    <MenuLogoStyled iscollapsed={`${isCollapsed}`}>
      <img
        src={isCollapsed ? imageCollapse : image}
        alt='Logo da maleta'
        onClick={() => navigate('/obras')}
      />
      {domain?.LogoUrl && !isCollapsed && (
        <img
          src={loadImage('powered-by.svg')}
          alt="decorative powered by logo"
          className="poweredByImg"
        />
      )}
    </MenuLogoStyled>
  );
};

export default MenuLogo;
